import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import ParagraphsWithColumns from "@modules/ParagraphsWithColumns"

const SupplyAndDemand = () => {
  const { t } = useTranslation()
  const params = {
    title: t("AboutMetaloop_Section4"),
    paragraphs: [
      {
        text: t("AboutMetaloop_Paragraph6"),
      },
      {
        text: t("AboutMetaloop_Paragraph7"),
      },
      {
        text: t("AboutMetaloop_Paragraph8"),
      },
    ],
  }
  return <ParagraphsWithColumns {...params} />
}

export default SupplyAndDemand